import {request} from "@/shared/api/request";
export const savePension = (data) => request({ url: `proactive/saveReq`, method: 'POST', data })